<template>
  <div style="width:100vw; height: 100vh">
    <cmdp-transfer
        domain="https://a.cmdp.cn"
        label="定期报告自动化项目"
        sample='{"_id": "64813369129899155678ac3f", "fullName": "中国广核电力股份有限公司", "simpleName": "中国广核", "secCode": "003816" }' 
		
		:year="yearConfigs['2022']['year']"
		:catlogPbcId="yearConfigs['2022']['catlogPbcId']"
		:recognPbcId="yearConfigs['2022']['recognPbcId']"
		:verifyPbcId="yearConfigs['2022']['verifyPbcId']"
		:tempHtmlPath="yearConfigs['2022']['tempHtmlPath']"
		:tempViewPath="yearConfigs['2022']['tempViewPath']"
		:tempCatlogPath="yearConfigs['2022']['tempCatlogPath']"
		:exportWordPbcId="yearConfigs['2022']['exportWordPbcId']"
		:exportRfPbcId="yearConfigs['2022']['exportRfPbcId']"
	></cmdp-transfer>
  </div>
</template>

<script>
export default {
  name: "readerTransfer",
  data() {
	  return {
			yearConfigs: {
				'default' : {
					year: "default",
					catlogPbcId: "api000134",
					recognPbcId: "file_no_arg_recognize",
					verifyPbcId: "api000311",
					tempHtmlPath: "usys/factory/factor/template/release/1676513097003651074/pzi9qe90gm4kueb68kiiebo8vg6dkorm.html",
					tempViewPath: "usys/factory/factor/template/release/1676513097003651074/18ec829a-b41d-44e8-b30f-9b34e17114db.json",
					tempCatlogPath: "usys/factory/factor/template/release/1676513097003651074/px8hc2xuiriuerwcprxcjhlt629p8d89.json",
					exportWordPbcId: "api000217",
					exportRfPbcId: "api000218",
				},
				'2022': {
					year: "2022",
					catlogPbcId: "api000134",
					recognPbcId: "file_no_arg_recognize",
					verifyPbcId: "api000311_2022",
					tempHtmlPath: "usys/factory/factor/template/release/1684480959465607169/y6yzlhijrajrbu6q2wm1cdtikb3wmydl.html",
					tempViewPath: "usys/factory/factor/template/release/1684480959465607169/c544c408-e947-4f38-b099-c91144ea332c.json",
					tempCatlogPath: "usys/factory/factor/template/release/1684480959465607169/a11kuhg05xu0gn1y55d1fjei2n3c6f8b.json",
					exportWordPbcId: "api000217",
					exportRfPbcId: "api000218_2022",
				},
				
			}
	  }
  },
  created() {
    sessionStorage.setItem( "USER_TOKEN_VAL", "36a8ba57-3edd-49ff-a83f-990885da8897" );
  }
}
</script>

<style scoped>

</style>
